import { Component } from '@angular/core';

@Component({
  selector: 'app-table-skeleton-loader',
  standalone: false,
  templateUrl: './table-skeleton-loader.component.html',
  styleUrl: './table-skeleton-loader.component.scss',
})
export class TableSkeletonLoaderComponent {}
